<script>
import LabelledBorder from '@/components/LabelledBorder'
import DropdownSelect from '@/components/DropdownSelect'
import TimePicker from '@/components/TimePicker'
import DateUtils from '@/utils/dateUtils'
import Vue from 'vue'

export default
{
    name: 'select-hours',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        const createDayCard = day =>
        {
            return <div class='day'>
                <div class='row'>
                    <div class='day-name'>{DateUtils.days.fr[day]}</div>
                    <inline-svg class='close-icon' src={require('@/assets/img/cross.svg')} on-click={() => this.deleteDay(day)} />
                </div>
                <div class='row'>
                    <div>matin</div>
                    <div>
                        de <time-picker type='time' format='HH:mm' use-text={true} v-model={this.days[day].morning[0]} /> à <time-picker type='time' format='HH:mm' use-text={true} v-model={this.days[day].morning[1]} />
                    </div>
                </div>
                <div class='row'>
                    <div>après-midi</div>
                    <div>
                        de <time-picker type='time' format='HH:mm' use-text={true} v-model={this.days[day].afternoon[0]} /> à <time-picker type='time' format='HH:mm' use-text={true} v-model={this.days[day].afternoon[1]} />
                    </div>
                </div>
            </div>
        }
            
        const options = JSON.parse(JSON.stringify(DateUtils.days.fr))

        Object.keys(this.days).forEach(d => delete options[d])

        return (
            <div class='select-hours'>
                <labelled-border ref='labelledBorder'>
                    <div class='label'>Heures d'ouverture</div>
                    <dropdown-select class='add-day' label='Ajouter un jour' v-model={this.selectedDay} show-selected={false}
                        options={options} />
                    { Object.keys(this.days).map(createDayCard) }
                </labelled-border>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            selectedDay: null,
            days: {},
            errorMessage: ''
        }
    },

    computed:
    {
    },

    watch:
    {
        selectedDay ()
        {
            this.errorMessage = ''
            const hours = JSON.parse(JSON.stringify(Object.values(this.days)[0] || { morning: ['', ''], afternoon: ['', ''] }))
            this.setDay(this.selectedDay, hours)
        },

        errorMessage ()
        {
            this.$refs.labelledBorder.errorMessage = this.errorMessage
        },

        days:
        {
            handler ()
            {
                this.errorMessage = ''
            },
            deep: true
        }
    },

    methods:
    {
        validate ()
        {
            this.errorMessage = ''
            var isValid = true

            const isIntervalValid = (from, to) => !(to < from) && !!from == !!to

            for (let [dayIdx, day] of Object.entries(this.days))
            {
                if (!isIntervalValid(...day.morning) || !isIntervalValid(...day.afternoon))
                {
                    this.errorMessage = 'Les horaires de ' + DateUtils.days.fr[dayIdx] + ' ne sont pas valides'
                    isValid = false
                    break
                }
            }

            return isValid
        },

        /**
         * @param {number|string} dayIndex
         * @param {object} day
         */
        setDay (dayIndex, day)
        {
            Vue.set(this.days, dayIndex, day)
        },

        /**
         * @param {number|string} dayIndex
         */
        deleteDay (dayIndex)
        {
            Vue.delete(this.days, dayIndex)
        }
    },

    components:
    {
        LabelledBorder,
        DropdownSelect,
        TimePicker
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.select-hours
{
    .labelled-border .content
    {
        padding: 15px;

        .row
        {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 5px;
        }

        .add-day
        {
            width: -webkit-fill-available;
        }

        .close-icon
        {
            width: 14px;
            height: 14px;
            fill: var(--theme-text-color-extra-light);
            margin-bottom: auto;
            cursor: pointer;
        }

        .day
        {
            width: -webkit-fill-available;
            background-color: var(--theme-content-background-color);
            padding: 12px 20px;
            border-radius: 8px;
            margin-top: 10px;
            box-shadow: var(--theme-box-shadow-soft);

            .time-picker
            {
                width: fit-content;
                font-size: 15px;
            }

            .day-name
            {
                font-weight: 600;
                margin-bottom: 10px;
                margin-bottom: 10px;

                .CapitalizeFirstLetter();
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/SelectHours.vue